import { render, staticRenderFns } from "./CommunityGrid.vue?vue&type=template&id=3febb9c2"
import script from "./CommunityGrid.vue?vue&type=script&lang=js"
export * from "./CommunityGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports